module.exports = __webpack_public_path__ + "img/location_tracking.472ea441.svg";